export default __webpack_public_path__ + "static/media/icon_download_transparent.1db2623c.svg";